import useAddRequestStore from 'store/addRequestStore';
import { classNames } from 'util/Funcs';

interface Props {
    isEditMode?: boolean;
}
export default function RequestOverviewInput({ isEditMode = false }: Props) {
    const { requestData, setRequestData, clearErrors, errors } = useAddRequestStore();
    return (
        <>
            <input
                type="text"
                id="title"
                value={requestData.title || ''}
                onChange={(e) => {
                    setRequestData({ title: e.target.value });
                    clearErrors('title');
                }}
                placeholder="Villa with pool in Bendinat"
                className={classNames(
                    isEditMode ? 'w-full' : 'w-full lg:w-1/2',
                    'px-3 py-4  bg-gray-50 border  rounded-md tex-lg',
                    errors.title ? 'border-red-500' : 'border-gray-200',
                )}
            />
            {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
        </>
    );
}
